import axios from "axios";
import { API_BASE_URL, getAuthToken } from "../artistStudio/shared";

// API helpers for the Sound Detail Page (/v1/sound/...). Reading works for guests; the rest needs a signed-in user.
const url = (id, path = "") => `${API_BASE_URL}/v1/sound/${encodeURIComponent(id)}${path}`;
const config = (extra = {}) => {
  const token = getAuthToken();
  return { headers: { ...(token ? { token } : {}), "Content-Type": "application/json" }, timeout: 15000, ...extra };
};
const result = (response) => response.data?.result;

export const soundApi = {
  detail: (id) => axios.get(url(id), config()).then(result),
  licences: (id) => axios.get(url(id, "/licences"), config()).then(result),
  useForFree: (id, body = { usage_class: "personal" }) => axios.post(url(id, "/licences/free"), body, config()).then(result),
  purchase: (id, body) => axios.post(url(id, "/licences/purchase"), body, config()).then(result),
  checkoutStart: (body) => axios.post(`${API_BASE_URL}/v1/licence-payment/checkout/start`, body, config()).then(result),
  checkoutConfirm: (body) => axios.post(`${API_BASE_URL}/v1/licence-payment/checkout/confirm`, body, config()).then(result),
  quote: (id, body) => axios.post(url(id, "/licences/quote"), body, config()).then(result),
  download: (id) => axios.get(url(id, "/download"), config()).then(result),
  playlists: (id) => axios.get(url(id, "/playlists"), config()).then(result),
  addToPlaylist: (id, body) => axios.post(url(id, "/playlists"), body, config()).then(result),
  save: (id) => axios.post(url(id, "/save"), {}, config()).then(result),
  unsave: (id) => axios.post(url(id, "/unsave"), {}, config()).then(result),
  like: (id) => axios.post(url(id, "/like"), {}, config()).then(result),
  unlike: (id) => axios.post(url(id, "/unlike"), {}, config()).then(result),
  composerLibrary: (params = {}) => axios.get(`${API_BASE_URL}/v1/sound/composer-library`, config({ params })).then(result),
  saved: (params = {}) => axios.get(`${API_BASE_URL}/v1/sound/saved`, config({ params })).then(result),
  videos: (id, params = {}) => axios.get(url(id, "/videos"), config({ params })).then(result),
  // A post made with a sound was watched or listened to (earns the artist royalties). start gives a ticket; the report must carry it.
  videoViewStart: (postId) => axios.post(`${API_BASE_URL}/v1/sound/video-view/start`, { post_id: postId }, config()).then(result),
  videoView: (postId, watchedSeconds, ticket) => axios.post(`${API_BASE_URL}/v1/sound/video-view`, { post_id: postId, watched_seconds: watchedSeconds, ticket }, config()).then(result),
};

export const errorStatus = (error) => error?.response?.status || null;
export const errorCode = (error) => error?.response?.data?.code || null;
export const errorText = (error, fallback = "Something went wrong. Please try again.") => error?.response?.data?.message || fallback;

// Why a sound cannot be shown at all (as opposed to a temporary failure that can be retried).
export const isUnavailable = (error) => [403, 404, 410].includes(errorStatus(error));

export const money = (price, currency = "USD") => {
  const n = Number(price);
  if (!Number.isFinite(n)) return "";
  if (n === 0) return "Free";
  try {
    return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(n);
  } catch (e) {
    return `${currency} ${n.toFixed(2)}`;
  }
};

export const formatDate = (iso) => {
  const d = iso ? new Date(iso) : null;
  return d && !Number.isNaN(d.getTime()) ? d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }) : "";
};
export const formatDateTime = (iso) => {
  const d = iso ? new Date(iso) : null;
  return d && !Number.isNaN(d.getTime()) ? d.toLocaleString(undefined, { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "";
};
